import type { ReactNode } from "react";
import { cn } from "@crew/ui/lib/utils";

export type Stat = { value: ReactNode; label: ReactNode };

/** Serif numbers in equal columns, ruled above and below ("6 Tasks done · 24m On computer"). */
export function StatRow({ stats, className }: { stats: Stat[]; className?: string }) {
  return (
    <div className={cn("flex border-y border-border py-3.5", className)}>
      {stats.map((stat, i) => (
        <div
          key={i}
          className={cn(
            "flex min-w-0 flex-1 flex-col gap-0.5 px-3.5 first:pl-0 last:pr-0",
            i < stats.length - 1 && "border-r border-border",
          )}
        >
          <span className="font-display text-[28px] leading-8 text-foreground tabular">
            {stat.value}
          </span>
          <span className="text-xs text-muted-foreground">{stat.label}</span>
        </div>
      ))}
    </div>
  );
}
